module.exports = __webpack_public_path__ + "static/card-fashion-03-a-7b151886353e4c6de45e9fabf946e793.png";